import reducer from "./reducer";
export { default as conceptGroups } from "./components/index";
export { default as conceptGroupsReducerName } from "./constants";
export default reducer;
